import * as types from "./types";

/**
 * Action creators du domaine Acts (Phase 2.F).
 *
 * <p>Les signatures publiques sont préservées pour ne pas casser les
 * composants existants — les sagas se chargent d'adapter le payload au
 * nouveau contrat (POST → Long → refetch).
 */

export const createActs = (payload) => ({
  type: types.CREATE_ACTS_REQUEST,
  payload,
});

export const updateActs = (payload) => ({
  type: types.UPDATE_ACTS_REQUEST,
  payload,
});

export const fetchAllActs = (payload) => ({
  type: types.FETCH_ACTS_REQUEST,
  payload,
});

export const getActsById = (payload) => ({
  type: types.GET_ACTS_BY_ID_REQUEST,
  payload,
});

export const deleteAct = (payload) => ({
  type: types.DELETE_ACTS_REQUEST,
  payload,
});

/**
 * Récupère les tarifs configurés pour un assureur donné via
 * {@code GET /acts-price-insurer/by-insurer/{insurerId}}.
 *
 * <p>Signature simplifiée (2026-05-26) : prend directement
 * l'{@code insurerId} en argument plutôt qu'un objet payload — fini
 * les variantes {@code {"insurer.id"}}, {@code {insurerId}}, {@code {id}}
 * de l'ancien alias {@code getActsPriceInsurerFilter}.
 */
export const getActsPriceInsurerByInsurer = (insurerId) => ({
  type: types.GET_ACTS_PRICE_INSURER_BY_INSURER_REQUEST,
  payload: insurerId,
});

export const createActsPriceInsurer = (payload) => ({
  type: types.CREATE_ACTS_PRICE_INSURER_REQUEST,
  payload,
});

export const updateActsPriceInsurer = (payload) => ({
  type: types.UPDATE_ACTS_PRICE_INSURER_REQUEST,
  payload,
});

export const deleteActsPriceInsurer = (payload) => ({
  type: types.DELETE_ACTS_PRICE_INSURER_REQUEST,
  payload,
});
